/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */

/* Services */

/**
 * Renders the SectionTitle component.
 *
 * @param titleObj.titleObj
 * @param {object} titleObj component.
 * @param {object} rest some more data
 * @param titleObj.section
 * @param titleObj.loadInit
 * @returns {ReactElement} SectionTitle component.
 */
export default function SectionTitle({ titleObj, loadInit, ...props }) {
  // console.log('title obj', titleObj)
  const titleColor = {
    'no-decoration': '#02026c',
    flowers: '#02026c',
    scribble: '#02026c',
    default: '#C9BAAB',
    samskriti: '#28231E',
    '': '#040404',
    // 'samskriti-2': '#ffffff',
    'orange-snake': '#ffffff',
    'scribble-brown': '#28231e',
    'blue-snake': '#28231E',
    'volunteer-flower': '#02026c',
    'orange-headless-snake': '#cf4520',
    'idy-subtext': '#02026c',
    'yoga-sandhya-leaf': '#000',
    'csr-reb-headless-snake': '#000',
  };

  const maxW = {
    'no-decoration': '770px',
    flowers: '770px',
    scribble: '770px',
    default: '770px',
    samskriti: '490px',
    // 'samskriti-2': '490px',
    'orange-snake': '490px',
    'scribble-brown': '770px',
    'blue-snake': '770px',
    '': '770px',
    'volunteer-flower': '770px',
    'orange-headless-snake': '770px',
    'idy-subtext': '400px',
    'yoga-sandhya-leaf': '549px',
    'csr-reb-headless-snake': '350px',
  };

  return (
    <>
      {(titleObj?.titleText || titleObj?.title) && (
        <Box
          className={`title-${titleObj?.titleDecoration || 'default'}`}
          maxW={props.w || maxW[titleObj?.titleDecoration || '']}
          mx="auto"
          w="auto"
          fontFamily="FedraSerifAStdBook"
          fontSize={{ base: '24px', md: '26px', lg: '46px', xl: '52px' }}
          lineHeight={{ base: '29px', md: '32px', lg: '56px', xl: '62px' }}
          color={titleColor[titleObj?.style]}
          textAlign="center"
          mt={{
            base: props.mt || '30px',
            md: props.mt || '30px',
          }}
          fontWeight="350"
          mb={{ base: '25px', sm: '30px', md: '40px', lg: '50px', xl: '60px' }}
          {...props}
        >
          <Box
            as="h2"
            display="inline"
            textTransform="uppercase"
            fontFamily="FedraSerifAStdBook"
            fontSize={{ base: '24px', md: '26px', lg: '46px', xl: '52px' }}
            lineHeight={{ base: '29px', md: '32px', lg: '56px', xl: '62px' }}
            color={titleColor[titleObj?.style]}
            textAlign="center"
            mt={{
              base: props.mt || '30px',
              md: props.mt || '30px',
            }}
            fontWeight="350"
            position={'relative'}
            // borderBottom={
            //   props.borderBottom ||
            //   borderBottom[titleObj?.titleDecoration || '']
            // }
          >
            <Box
              as="span"
              _after={{
                content: "''",
                display: props.noBorder ? 'none' : 'block',
                position: 'absolute',
                width: '45%',
                height: '2px',
                bottom: '0',
                left: '27%',
                background: titleColor.default,
              }}
            >
              {titleObj?.title || titleObj?.titleText}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
}
